import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8 px-5 mt-5 mx-auto" }
const _hoisted_5 = { class: "card card-danger" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-warning" }),
  /*#__PURE__*/_createTextVNode(" Oops! acceso denegado. ")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" No tienes permiso para acceder a este recurso. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("volver al dashboard")

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}